import React, { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import apiClient from '../api/axios';
import { toast } from 'react-toastify';
import { Container, Card, Button, Spinner, Alert, ListGroup } from 'react-bootstrap';

const PublicLibrariesPage = () => {
    const [publicLibraries, setPublicLibraries] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    const fetchData = useCallback(async () => {
        setLoading(true);
        try {
            const libsResponse = await apiClient.get('/songs/public-libraries/');
            setPublicLibraries(libsResponse.data);
        } catch (err) {
            setError('Не удалось загрузить список публичных фонотек.');
            toast.error('Ошибка загрузки данных.');
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    if (loading) {
        return (
            <Container className="mt-5 text-center">
                <Spinner animation="border" role="status">
                    <span className="visually-hidden">Загрузка...</span>
                </Spinner>
            </Container>
        );
    }

    if (error) {
        return (
            <Container className="mt-5">
                <Alert variant="danger">{error}</Alert>
            </Container>
        );
    }

    return (
        <Container className="mt-4">
            <h1>Общие фонотеки</h1>
            <p className="text-muted">Просматривайте публичные фонотеки и копируйте понравившиеся песни в свою базу.</p>
            
            {publicLibraries.length === 0 ? (
                <p>Пока нет ни одной публичной фонотеки.</p>
            ) : (
                <ListGroup>
                    {publicLibraries.map(lib => (
                        <ListGroup.Item key={lib.id} className="d-flex justify-content-between align-items-center">
                            <div>
                                <h5 className="mb-1">{lib.name}</h5>
                                <p className="mb-1 text-muted">{lib.description || ''}</p>
                            </div>
                            <div>
                                <Link to={`/public-libraries/${lib.id}`} className="btn btn-outline-primary btn-sm me-2">
                                    Просмотр
                                </Link>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>
            )}
        </Container>
    );
};

export default PublicLibrariesPage;
